import Events from "@wwdev/bootstrap/Events";

class Indicator {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-indicator]'
		}, config);

		let $scope = $(this.config.scope);
		if($scope.length > 0) {
			this.init();
		}
	}

	init() {
		Events.on('wwdev.winkelwagen.indicator.refresh', this.refreshIndicators.bind(this));
	}

	refreshIndicators() {
		let url = $('meta[name="shopping-cart-url"]').attr('content');
		$.ajax({
			url: url,
			method: 'POST',
			data: {
				action: 'indicator'
			},
			success: this.onSuccess.bind(this),
			error: this.onError.bind(this),
		})
	}

	onSuccess(response) {
		$(this.config.scope).each((index, scope) => {
			let $scope = $(scope);
			let type = $scope.data('indicator');
			if(type === 'dropdown') {
				$scope.after(response.dropdown);
			} else {
				$scope.after(response.default);
			}
			$scope.remove();
		});
	}

	onError(error) { }
}

export default Indicator;